import type { KeyboardEvent } from "react";
import type { EditorMove } from "../editActions";

export type ArrowMoves = Partial<Record<string, EditorMove>>;

export const NO_ARROW_MOVES: ArrowMoves = {};
export const ARROW_MOVES: ArrowMoves = {
    ArrowUp: "up",
    ArrowDown: "down",
    ArrowLeft: "left",
    ArrowRight: "right",
};

/** Excel's commit keys: Enter moves down, Tab right, Shift reverses them. */
export const getEditorKeyMove = (
    event: Pick<KeyboardEvent, "key" | "shiftKey">,
    arrowMoves: ArrowMoves,
): EditorMove | null => {
    if (event.key === "Enter") {
        return event.shiftKey ? "up" : "down";
    }
    if (event.key === "Tab") {
        return event.shiftKey ? "left" : "right";
    }
    return arrowMoves[event.key] ?? null;
};
